import { WebClientListResourceFetcher } from '~commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { GetPublishedConnectionColumnsRequest } from '~src/publishedConnection/serverApi/requests/GetPublishedConnectionColumnsRequest';
import { IPublishedConnectionColumnInfo } from '~src/publishedConnectionTable/models/IPublishedConnectionTableInfo';
import { IListFetcher } from '~src/ts/fetchers/IListFetcher';
import { ServerApiMapper } from '~src/ts/helpers/ServerModelHelper';
import { IListResource } from '~src/ts/resources/Resource';
import { ResourceQuery } from '~src/ts/resources/ResourceQuery';

class PublishedConnectionColumnsResource implements IListResource<IPublishedConnectionColumnInfo> {

  private listFetcher: IListFetcher<IPublishedConnectionColumnInfo> = new WebClientListResourceFetcher(GetPublishedConnectionColumnsRequest, ServerApiMapper.publishedConnectionColumns);

  public all(): ResourceQuery<IPublishedConnectionColumnInfo> {
    return new ResourceQuery(this.listFetcher);
  }
}

export const PublishedConnectionColumns = new PublishedConnectionColumnsResource();
